
import { getPublicData } from "../../../../../services/publicPegasApi/MakePublicOrder";

export default async function PrintReportStatistics(
  printData = {},
  invoiceData = {},
  orderId,
  options = {}
) {
  let publicData = {};
  try {
    publicData = await getPublicData();
    console.log("📞 بيانات الشركة المسترجعة:", publicData);
  } catch (err) {
    console.error("❌ فشل في جلب البيانات العامة:", err);
  }

  const logoUrl = publicData?.logo ? publicData.logo.trim().replace(/\s+/g, "") : "";
  console.log("🖼️ رابط اللوجو النهائي:", logoUrl);

  // =========================
  // ✅ THERMAL CONFIG
  // =========================
  const paperWidthMm = Number(options?.paperWidthMm || 80); // 80 recommended even for 88mm rolls
  const fontSize = options?.fontSize ? Number(options.fontSize) : 12;

  const formatMoney = (v) => {
    const n = parseFloat(v);
    return (isNaN(n) ? 0 : n).toFixed(2);
  };

  const normalizeType = (t) => String(t || "").trim().toLowerCase();

  // =========================
  // ✅ MULTI-SESSION DAILY REPORT (THERMAL) OR PRODUCT STATISTICS
  // =========================
  if (Array.isArray(printData)) {
    const sessions = printData;
    const title = options?.title || "تقرير";

    // If array items look like product stats (from ReportStatistics), render product table
    if (sessions.length > 0 && sessions[0].product_name) {
      const products = sessions;
      const rows = products
        .map(
          (p, idx) => `
            <tr>
              <td class="idx">${idx + 1}</td>
              <td class="name">${p.product_name || "-"}</td>
              <td class="qty">${Number(p.total_sold || 0)}</td>
              <td class="rev">${Number(p.total_amount || 0).toFixed(2)}</td>
            </tr>`,
        )
        .join("");

      const html = `<!doctype html>
<html dir="rtl">
<head>
  <meta charset="utf-8" />
  <title>${title}</title>
  <style>
    @page { size: ${paperWidthMm}mm auto; margin: 0; }
    html, body { margin: 0; padding: 0; background: #fff; }
    body { font-family: Arial, Helvetica, sans-serif; direction: rtl; }
    .wrap { width: ${paperWidthMm}mm; padding: 8px; box-sizing: border-box; color: #000; }
    .logo { max-width: 220px; display:block; margin: 0 auto 6px; }
    h1 { text-align:center; margin:6px 0; }
    .meta { text-align:center; color:#666; margin-bottom:8px }
    table { width:100%; border-collapse: collapse; margin-top:8px; }
    th, td { padding:6px 4px; border-bottom:1px solid #ddd; text-align:right }
    th { background:#f5f5f5; font-weight:700 }
    .idx { width:6%; }
    .qty { width:18%; text-align:center }
    .rev { width:22%; text-align:center }
    .totals { margin-top:10px; font-weight:700; text-align:center }
  </style>
</head>
<body>
  <div class="wrap">
    ${
      logoUrl
        ? `<img src="${logoUrl}" class="logo" alt="logo" onerror="this.style.display='none'"/>`
        : ""
    }
    <h1>${title}</h1>
    <div class="meta">الفترة: ${options?.fromDate || "-"} → ${options?.toDate || "-"}</div>
    <table>
      <thead>
        <tr>
          <th class="idx">#</th>
          <th>اسم المنتج</th>
          <th class="qty">الكمية</th>
          <th class="rev">الإيراد</th>
        </tr>
      </thead>
      <tbody>
        ${rows || `<tr><td colspan="4" style="text-align:center">لا توجد بيانات</td></tr>`}
      </tbody>
    </table>
    <div class="totals">إجمالي الكمية: ${options?.totalSold || 0} — إجمالي الإيراد: ${Number(options?.totalAmount || 0).toFixed(2)} ج</div>
    <p style="text-align:center;margin-top:12px;color:#999">تم بواسطة نظام ريستو كاش</p>
  </div>
</body>
</html>`;

      return html;
    }

    // fallback: existing multi-session rendering
    const rowsHtml = sessions
      .map((s) => {
        const grouped = s.grouped_transactions_by_shift || {};
        const totalTx = Object.values(grouped).reduce(
          (acc, arr) => acc + (Array.isArray(arr) ? arr.length : 0),
          0
        );

        // ✅ اجماليات اليومية (Invoices / Deposit / Withdrawal / Expenses)
        let sessionInvoicesTotal = 0;
        let sessionDepositTotal = 0;
        let sessionWithdrawalTotal = 0;
        let sessionExpensesTotal = 0;

        Object.values(grouped).forEach((txArray) => {
          (txArray || []).forEach((tx) => {
            const type = normalizeType(tx?.type);
            const amt = parseFloat(tx?.amount || 0) || 0;

            // الفاتورة: الأفضل الاعتماد على invoice.total_amount لو موجود
            if (tx?.invoice?.total_amount != null) {
              sessionInvoicesTotal += parseFloat(tx.invoice.total_amount) || 0;
              return;
            }

            // fallback لو tx.type === invoice
            if (type === "invoice") {
              sessionInvoicesTotal += amt;
              return;
            }

            if (type === "deposit") sessionDepositTotal += amt;
            else if (type === "withdrawal") sessionWithdrawalTotal += amt;
            else if (type === "expenses" || type === "expense") sessionExpensesTotal += amt;
          });
        });

        const shiftsHtml = Object.entries(grouped)
          .map(([shiftName, txs]) => {
            const list = Array.isArray(txs) ? txs : [];

            // جدول حراري مختصر + سطر تفاصيل إضافي لكل عملية
            const txRows = list
              .map((tx, idx) => {
                const type = tx?.type || "-";
                const amt = tx?.amount ?? "-";
                const bank = tx?.bank?.name || "-";
                const date = tx?.transaction_date || "-";
                const invId = tx?.invoice?.id ?? "-";
                const bankTo = tx?.bank_to?.name || "-";
                const bankFrom = tx?.bank_from?.name || "-";

                return `
                  <tr>
                    <td class="col-idx">${idx + 1}</td>
                    <td class="col-type">${type}</td>
                    <td class="col-amt">${amt}</td>
                    <td class="col-bank">${bank}</td>
                    <td class="col-date">${date}</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="tx-note">
                      فاتورة: ${invId}
                      <span class="soft"> | إلى: ${bankTo} | من: ${bankFrom}</span>
                    </td>
                  </tr>
                `;
              })
              .join("");

            return `
              <div class="section">
                <h4>الوردية: ${shiftName}</h4>
                <table>
                  <thead>
                    <tr>
                      <th class="col-idx">م</th>
                      <th class="col-type">النوع</th>
                      <th class="col-amt">المبلغ</th>
                      <th class="col-bank">الخزنة</th>
                      <th class="col-date">التاريخ</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${
                      txRows ||
                      `<tr><td colspan="5" class="empty">لا توجد عمليات</td></tr>`
                    }
                  </tbody>
                </table>
              </div>
            `;
          })
          .join("");

        const netSession = sessionInvoicesTotal + sessionDepositTotal - sessionWithdrawalTotal - sessionExpensesTotal;

        return `
          <div class="block">
            <h3>اليومية: ${s.session_id ?? "-"} — ${s.session_date ?? "-"}</h3>
            <p>المستخدم: ${s.user?.name || "-"} (${s.user?.username || "-"})</p>
            <p>عدد العمليات: ${totalTx}</p>
            <hr />
            ${shiftsHtml || `<p class="empty">لا توجد ورديات/عمليات</p>`}

            <hr />
            <div class="totals">
              <p><strong>إجمالي الفواتير:</strong> ${formatMoney(sessionInvoicesTotal)} ج</p>
              <p><strong>إجمالي الإيداعات:</strong> ${formatMoney(sessionDepositTotal)} ج</p>
              <p><strong>إجمالي السحوبات:</strong> ${formatMoney(sessionWithdrawalTotal)} ج</p>
              <p><strong>إجمالي المصروفات:</strong> ${formatMoney(sessionExpensesTotal)} ج</p>
              <p class="net"><strong>صافي اليومية:</strong> ${formatMoney(netSession)} ج</p>
            </div>
          </div>
        `;
      })
      .join("");

    const html = `<!doctype html>
<html dir="rtl">
<head>
  <meta charset="utf-8" />
  <title>${options?.title || "تقرير"}</title>
  <style>
    @page { size: ${paperWidthMm}mm auto; margin: 0; }
    html, body { margin: 0; padding: 0; background: #fff; }
    body { font-family: Arial, Helvetica, sans-serif; direction: rtl; }

    .receipt {
      width: ${paperWidthMm}mm;
      padding: 6px;
      box-sizing: border-box;
      font-size: ${fontSize}px;
      color: #000;
    }

    .logo-wrap { text-align: center; margin: 6px 0 10px; }
    .logo { max-width: 240px; max-height: 80px; object-fit: contain; }

    h1, h2, h3, h4 { margin: 6px 0; text-align: center; }
    p { margin: 3px 0; }
    hr { border: none; border-top: 1px dashed #000; margin: 8px 0; }

    .block { padding: 8px 0; border-bottom: 1px dashed #000; }
    .section { margin-top: 8px; }

    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      margin-top: 6px;
      font-size: ${fontSize - 1}px;
    }

    th, td {
      padding: 4px 2px;
      text-align: right;
      vertical-align: top;
      word-break: break-word;
    }

    thead th {
      border-bottom: 1px dashed #000;
      font-weight: bold;
    }

    tbody td {
      border-bottom: 1px dashed #ddd;
    }

    .col-idx { width: 10%; }
    .col-type { width: 22%; }
    .col-amt { width: 18%; }
    .col-bank { width: 25%; }
    .col-date { width: 25%; }

    .tx-note {
      padding: 4px 2px 6px;
      border-bottom: 1px dashed #000;
      font-size: ${fontSize - 2}px;
    }

    .soft { opacity: 0.9; }
    .empty { text-align: center; padding: 8px 0; }

    .totals {
      font-size: ${fontSize - 1}px;
      padding: 2px 0;
    }
    .totals p { margin: 4px 0; }
    .totals .net {
      text-align: center;
      margin-top: 6px;
      font-size: ${fontSize}px;
    }
  </style>
</head>
<body>
  <div class="receipt">
    ${
      logoUrl
        ? `<div class="logo-wrap">
             <img src="${logoUrl}" class="logo" alt="logo" onerror="this.style.display='none'"/>
           </div>`
        : ""
    }
    <h1>${publicData?.name || options?.title || "تقرير"}</h1>
    <h2>إجمالي اليوميات: ${sessions.length}</h2>
    <hr />
    ${rowsHtml}
    <p style="text-align:center;margin-top:10px">تم بواسطة نظام ريستو كاش</p>
  </div>
</body>
</html>`;

    return html;
  }

  // =========================
  // ✅ SINGLE ORDER RECEIPT (OLD BEHAVIOR)
  // =========================
  const orderDetails = printData || {};
  const inv = invoiceData || {};
  const items = orderDetails.items || [];

  const subtotal = items.reduce((acc, item) => {
    const price = parseFloat(
      item.price ||
        item.unit_price ||
        (item.total && item.quantity ? item.total / item.quantity : 0) ||
        0
    );
    return acc + (isNaN(price) ? 0 : price) * parseFloat(item.quantity || 0);
  }, 0);

  const service = parseFloat(inv.service || 0);
  const tax = parseFloat(inv.tax || 0);
  const discount = parseFloat(inv.discount || 0);
  const total = subtotal + service + tax - discount;

  const footerText = (() => {
    const base = (inv.footer_text || "").trim();
    const note = (publicData?.invoice_note_printer || "").trim();
    const pieces = [];
    if (base) pieces.push(base);
    if (note) pieces.push(note);
    return pieces.join("<br/>");
  })();

  const address = publicData?.address || "";
  const phone = publicData?.phone || "";

  const orderPrintNumber = inv?.order_print_number || 1;

  return `
<!DOCTYPE html>
<html dir="rtl">
<head>
  <meta charset="UTF-8" />
  <style>
    @page { size: ${paperWidthMm}mm auto; margin: 0; }
    html, body { height: 100%; margin: 0; padding: 0; background: #fff; }
    .receipt {
      font-family: 'Cairo', Arial, sans-serif;
      width: ${paperWidthMm}mm;
      padding: 8px;
      margin: 0 auto;
      font-size: ${fontSize}px;
      color: #000;
      direction: rtl;
      text-align: right;
      box-sizing: border-box;
    }
    h2, h3 { margin: 4px 0; text-align: center; }
    hr { border: none; border-top: 1px dashed #000; margin: 6px 0; }
    table { width: 100%; border-collapse: collapse; table-layout: fixed; }
    th, td { padding: 3px 0; text-align: right; word-break: break-word; }
    th { border-bottom: 1px dashed #000; }
    .footer { text-align: center; margin-top: 10px; font-size: ${fontSize - 1}px; }
    .logo { max-width: 240px; max-height: 120px; object-fit: contain; display: block; margin: 0 auto 10px; }
  </style>
</head>
<body>
  <div class="receipt">
    ${logoUrl ? `<img src="${logoUrl}" class="logo" alt="Logo" onerror="this.style.display='none'" />` : ""}
    <h2>${inv.header_text || publicData?.name || "تطبيق رستو كاش"}</h2>
    <h3>فاتورة رقم #${orderDetails.general_increment || orderId || "-"}</h3>
    <h3>رقم الفاتورة: ${orderId ?? "-"}</h3>
    <p><strong>عدد مرات الطباعة:</strong> ${orderPrintNumber}</p>
    <hr />
    <p>العميل: ${orderDetails.customer?.name || "بدون اسم"}</p>
    <p>الطاولة: ${orderDetails.table?.name || "غير محددة"}</p>
    <hr />
    <table>
      <thead>
        <tr>
          <th>الصنف</th>
          <th>السعر</th>
          <th>الكمية</th>
          <th>الإجمالي</th>
        </tr>
      </thead>
      <tbody>
        ${items
          .map((item) => {
            const price = parseFloat(
              item.price ||
                item.unit_price ||
                (item.total && item.quantity ? item.total / item.quantity : 0)
            );
            return `
              <tr>
                <td>${item.product_name || "-"}</td>
                <td>${(isNaN(price) ? 0 : price).toFixed(2)} ج</td>
                <td>${item.quantity || 0}</td>
                <td>${(parseFloat(item.total) || 0).toFixed(2)} ج</td>
              </tr>
            `;
          })
          .join("")}
      </tbody>
    </table>
    <hr />
    <p>الإجمالي الفرعي: ${subtotal.toFixed(2)} ج</p>
    <p>الخدمة: ${service.toFixed(2)} ج</p>
    <p>الضريبة: ${tax.toFixed(2)} ج</p>
    <p>الخصم: ${discount.toFixed(2)} ج</p>
    <hr />
    <h3>الإجمالي الكلي: ${total.toFixed(2)} ج</h3>
    <hr />
    <div class="footer">
      ${footerText ? `<p>${footerText}</p>` : `<p>شكرًا لزيارتكم ❤️</p>`}
      ${address ? `<p>📍 العنوان: ${address}</p>` : ""}
      ${phone ? `<p>📞 الهاتف: ${phone}</p>` : ""}
      <p>تم بواسطة نظام ريستو كاش</p>
    </div>
  </div>
</body>
</html>
  `;
}
